type Props = {
  query?: string
  className?: string
  children: string
}

export const Highlight = ({ query, className, children }: Props) => {
  if (!query) return <p className={className}>{children}</p>

  // 쿼리를 공백으로 분리하여 각 단어 추출
  const queryWords = query
    .trim()
    .split(/\s+/)
    .filter(word => word.length > 0)

  if (queryWords.length === 0) return <p className={className}>{children}</p>

  // 특수문자를 리터럴로 사용하기 위해 이스케이프
  const escapedWords = queryWords.map(word =>
    word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
  )

  // 모든 단어를 하나의 정규식으로 결합 (포획 괄호 사용)
  const regexPattern = `(${escapedWords.join('|')})` // (서울|서초)
  const re = new RegExp(regexPattern, 'gi') // /(서울|서초)/gi

  if (!children.match(re)) {
    return <p className={className}>{children}</p>
  }

  let highlightedHtml = children.replace(
    re,
    match =>
      `<mark class="bg-inherit font-bold text-purple-500">${match}</mark>`,
  )

  // 연속된 </mark><mark> 패턴을 제거하여 병합
  highlightedHtml = highlightedHtml.replace(/<\/mark><mark[^>]*>/g, '')

  return (
    <p
      className={className}
      dangerouslySetInnerHTML={{ __html: highlightedHtml }}
    />
  )
}
